var Render = {

        operations: [],

        add: function(selector, callback) {
        this.operations.push({
            selector: selector,
            callback: callback
        });
        return this;
    },

        do: function(context){
        context = context || document.getElementsByTagName("html")[0];

                this.operations.forEach(function(operation, index){
            if (typeof operation.callback == "function" && typeof operation.selector == "string") {
                var $objects = $(operation.selector, context);
                $objects.each(function(){
                    if (!$(this).hasClass("rendered")) {
                        var result = operation.callback.call(this);
                        result !== false && $(this).addClass('rendered');
                    }
                })
            }
        })
    }

    };

